import { useCallback } from 'react';
import {
  CalendarFillIcon,
  CalendarLineIcon,
  Chat1FillIcon,
  Chat1LineIcon,
  HandHeartFillIcon,
  HandHeartLineIcon,
  HeartBeatLineIcon,
  HeartFillIcon,
  HeartLineIcon,
  HeartbeatIcon,
  MortarboardFillIcon,
  MortarboardLineIcon,
  NotificationFillIcon,
  NotificationLineIcon,
  VideoFillIcon,
  VideoLineIcon,
} from 'ui';

export const useNotificationIcon = () => {
  // eslint-disable-next-line sonarjs/cognitive-complexity -- Its only switch with icons, no cognitive load
  const getIcon = useCallback(({ iconType, isRead }: { iconType: string; isRead: boolean }) => {
    const type = isRead ? undefined : 'primary';
    const size = 'middle';

    switch (iconType) {
      case 'activity':
        return isRead ? <HeartBeatLineIcon size={size} /> : <HeartbeatIcon size={size} type={type} />;
      case 'calendar':
        return isRead ? <CalendarLineIcon size={size} /> : <CalendarFillIcon size={size} type={type} />;
      case 'comment':
        return isRead ? <Chat1LineIcon size={size} /> : <Chat1FillIcon size={size} type={type} />;
      case 'donation':
      case 'giving':
        return isRead ? <HandHeartLineIcon size={size} /> : <HandHeartFillIcon size={size} type={type} />;
      case 'like':
        return isRead ? <HeartLineIcon size={size} /> : <HeartFillIcon size={size} type={type} />;
      case 'program':
        return isRead ? <MortarboardLineIcon size={size} /> : <MortarboardFillIcon size={size} type={type} />;
      case 'user':
        return isRead ? <NotificationLineIcon size={size} /> : <NotificationFillIcon size={size} type={type} />;
      case 'video':
        return isRead ? <VideoLineIcon size={size} /> : <VideoFillIcon size={size} type={type} />;
      default:
        return isRead ? <NotificationLineIcon size={size} /> : <NotificationFillIcon size={size} type={type} />;
    }
  }, []);

  return { getIcon };
};
